module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "content"
    }
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    attrs: {
      "id": "main-colum"
    }
  }, [_c('div', {
    staticClass: "success-box"
  }, [_c('div', {
    staticClass: "sprite success",
    staticStyle: {
      "display": "inline-block",
      "float": "left"
    }
  }), _vm._v(" Thank you for your purchase!\n      ")]), _vm._v(" "), _c('p')])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-e3fc4ad2!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/PaymentSuccess.vue
// module id = 528
// module chunks = 1